import set from "@rill/set";
import _ from "lodash";
import get from "lodash/get";
import moment from "moment";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import { isAdminOrOwner } from "../../../utils/organization-permissions-helpers";
import { firstQuestionnaireUtc } from "../../../utils/readiness-report";
import ReadinessRate from "./readiness/ReadinessRate";

const ReadinessRateController = (app) => {
  app.get(
    "/readiness-rate",
    set("heading", "Readiness Rate"),
    async ({ req, res, locals, load }) => {
      const isAllowToViewAllOrganizationsAthletes = isAdminOrOwner(
        locals.organizationRoleName
      );

      if (
        locals.activeUser.organizationId &&
        isAllowToViewAllOrganizationsAthletes &&
        !locals.allAthletesFromOrganization
      ) {
        await load("allAthletesFromOrganization");
      }
      // The report needs to know which days were training days, from the first questionnaire on
      const firstUtc = firstQuestionnaireUtc(locals.dailyStats);
      if (firstUtc !== null) {
        await load("trainingDays", {
          start: moment(String(firstUtc), "YYYYMMDD"),
          end: moment(),
          proxyAthlete: req.query.athlete,
        });
      }
      const modal = get(req.query, "modal", {});
      locals.modal = {
        "activity-feed": <ActivityDrawer />,
      }[modal.type];
      res.body = <ReadinessRate />;
    }
  );
};

export default ReadinessRateController;
